// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Desktop Navbar  */
.Navbar_desktopNavbar__U7\\+gs {
    position: fixed;
    width: 100%;
    height: auto;
    min-height: 65px;
    top: 50px;
    display: flex;
    align-items: center;
    justify-content: center; 
    z-index: 100;
    padding: 0 15px;
    z-index: 9999;
}

.Navbar_desktopNavbar__U7\\+gs .Navbar_container__6oUZ- {
    width: 100%;
    background-color: #ffffff6b;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-radius: 16px;
    position: relative;
    max-height: 65px;
    backdrop-filter: blur(10px);
}

.Navbar_mainDiv__JYREL {
    width: 80%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.Navbar_logo__o8J8F {
    width: 50px;
    height: 60px;
    flex-shrink: 0;
}

.Navbar_logo__o8J8F img {
    max-width: 100%;
    height: 100%;
    border-radius: 16px;
    object-fit: cover;
}

.Navbar_menu__KEoY\\+ {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
    align-items: center;
    gap: 8px; 
}

.Navbar_menu__KEoY\\+ li {
    margin: 0;
}

.Navbar_menu__KEoY\\+ .Navbar_links__8lRvB {
    padding: 10px 20px;
    text-decoration: none;
    color: rgba(1, 89, 51, 0.6);
    white-space: nowrap;
    transition: all 0.3s ease;
    font-weight: 500;
    display: block;
    border-radius: 20px;
    position: relative;
    overflow: hidden;
    min-width: auto;
}

.Navbar_menu__KEoY\\+ .Navbar_links__8lRvB:hover {
    color: #ccc;
}
.Navbar_menu__KEoY\\+ .Navbar_links__8lRvB::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #015933 0%, #013d26 100%);
    opacity: 0.9;
    transition: left 0.4s ease;
    z-index: -1;
    border-radius: 20px;
}

.Navbar_menu__KEoY\\+ .Navbar_links__8lRvB.Navbar_active__zz1Pj::before {
    left: 0;
}

.Navbar_menu__KEoY\\+ .Navbar_links__8lRvB.Navbar_active__zz1Pj {
    color: white;
    padding: 10px 24px;
}

.Navbar_menu__KEoY\\+ .Navbar_links__8lRvB:hover {
    color: rgba(1, 89, 51, 0.8);
    transform: translateY(-2px);
}


.Navbar_desktopSearch__w-BXb {
    display: block;
    flex-shrink: 0;
    /* width: 20%; */
}

/* Mobile Bottom Navigation */
.Navbar_mobileBottomNav__kwCM9 {
    display: none;
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    z-index: 1000;
    padding: 0 10px 10px;
}

.Navbar_mobileNavContainer__uuy9O {
    background-color: #ffffff6b;;
    backdrop-filter: blur(10px);
    border-radius: 25px;
    padding: 12px 8px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: 0 -10px 40px rgba(1, 89, 51, 0.15);
    border: 2px solid rgba(1, 89, 51, 0.1);
    margin: 0 auto;
}

.Navbar_navItem__Ix8Nh {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: rgba(1, 89, 51, 0.6);
    transition: all 0.3s ease;
    border-radius: 20px;
    padding: 10px 12px;
    position: relative;
    overflow: hidden;
    min-width: 50px;
    justify-content: center;
}

.Navbar_navItem__Ix8Nh::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #015933 0%, #013d26 100%);
    transition: left 0.4s ease;
    z-index: -1;
    border-radius: 20px;
}

.Navbar_navItem__Ix8Nh.Navbar_active__zz1Pj::before {
    left: 0;
}



.Navbar_navItem__Ix8Nh.Navbar_active__zz1Pj {
    color: white;
    padding: 10px 16px;
    /* min-width: auto; if it made a problem for the nav get it back */
}

.Navbar_navItem__Ix8Nh:hover {
    color: rgba(1, 89, 51, 0.8);
    transform: translateY(-2px);
}

.Navbar_navItem__Ix8Nh:hover .Navbar_navIcon__jwXGd {
    transform: scale(1.1);
}

.Navbar_navContent__2rqnf {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
    z-index: 1;
}

.Navbar_navIcon__jwXGd {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.Navbar_navIcon__jwXGd img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: opacity(0.8);
    transition: filter 0.3s ease;
}

.Navbar_navIcon__jwXGd svg {
    width: 24px;
    height: 24px;
    opacity: 0.8;
    transition: opacity 0.3s ease;
}

.Navbar_navItem__Ix8Nh.Navbar_active__zz1Pj .Navbar_navIcon__jwXGd img {
    filter: brightness(0) invert(1);
}

.Navbar_navItem__Ix8Nh.Navbar_active__zz1Pj .Navbar_navIcon__jwXGd svg {
    color: white;
    opacity: 1;
}

.Navbar_navLabel__n1r8s {
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    opacity: 0;
    transform: translateX(-10px);
    transition: all 0.3s ease;
    max-width: 0;
    overflow: hidden;
}

.Navbar_navItem__Ix8Nh.Navbar_active__zz1Pj .Navbar_navLabel__n1r8s {
    opacity: 1;
    transform: translateX(0);
    max-width: 100px;
}

/* Phone Search  */
.Navbar_mobileSearchOverlay__\\+t1p6 {
    position: absolute;
    top: 75px;
    left: 10px;
    right: 10px;
    background: #ffffff6b;
    backdrop-filter: blur(20px);
    border-radius: 25px;
    padding: 15px;
    box-shadow: 0 -10px 40px rgba(1, 89, 51, 0.15);
    border: 2px solid rgba(1, 89, 51, 0.1);
    z-index: 999;
    animation: Navbar_slideDown__p2\\+PX 0.3s ease-out;
}

@keyframes Navbar_slideDown__p2\\+PX {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.Navbar_mobileSearchContainer__gERQI {
    display: flex;
    align-items: center;
    gap: 10px;
}

.Navbar_mobileSearchContainer__gERQI .Navbar_searchContainer__vOYsE {
    flex: 1 1;
}

.Navbar_closeSearchBtn__\\+h2ow {
    background: none;
    border: none;
    color: #015933;
    padding: 8px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    width: 36px;
    height: 36px;
}

.Navbar_closeSearchBtn__\\+h2ow:hover {
    background-color: rgba(1, 89, 51, 0.1);
    transform: scale(1.1);
}

/* Search Item Button Styles */
.Navbar_searchItem__qanZu {
    background: none;
    border: none;
    cursor: pointer;
    font-family: inherit;
}

.Navbar_searchItem__qanZu.Navbar_active__zz1Pj {
    background: linear-gradient(135deg, #015933 0%, #013d26 100%) !important;
}

.Navbar_searchItem__qanZu.Navbar_active__zz1Pj::before {
    left: 0;
}

.Navbar_navItem__Ix8Nh, .Navbar_searchItem__qanZu {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: rgba(1, 89, 51, 0.6);
    transition: all 0.3s ease;
    border-radius: 20px;
    padding: 10px 12px;
    position: relative;
    overflow: hidden;
    min-width: 50px;
    justify-content: center;
}

/* Phone Search Responsive */
@media (max-width: 480px) {
    .Navbar_mobileSearchOverlay__\\+t1p6 {
        top: -65px;
        padding: 12px;
        border-radius: 20px;
    }
    
    .Navbar_closeSearchBtn__\\+h2ow {
        width: 32px;
        height: 32px;
    }
}

@media (min-width: 576px) {
    .Navbar_container__6oUZ-, .Navbar_containerSm__xYDlg {
        max-width: 540px;
    }
}

@media (min-width: 768px) {
    .Navbar_container__6oUZ-, .Navbar_containerMd__448Gs {
        max-width: 720px;
    }
    
    .Navbar_mobileNavContainer__uuy9O {
        padding: 14px 10px;
    }
    
    .Navbar_navIcon__jwXGd {
        width: 26px;
        height: 26px;
    }
    
    .Navbar_navLabel__n1r8s {
        font-size: 13px;
    }
}

@media (min-width: 992px) {
    .Navbar_container__6oUZ-, .Navbar_containerLg__3IKqO {
        max-width: 960px;
    }
}

@media (min-width: 1200px) {
    .Navbar_container__6oUZ-, .Navbar_containerXl__BKbG4 {
        max-width: 1140px;
    }
}

@media (min-width: 1400px) {
    .Navbar_container__6oUZ-, .Navbar_containerXxl__bYKFr {
        max-width: 1320px;
    }
}

@media (min-width: 1600px) {
    .Navbar_container__6oUZ-, .Navbar_containerXxxl__QrWWx {
        max-width: 1500px;
    }
}

@media (min-width: 1920px) {
    .Navbar_container__6oUZ-, .Navbar_container4k__OG6to {
        max-width: 1800px;
    }
}

/* Phone Responsive  */
@media (max-width: 1024px) {
    .Navbar_menu__KEoY\\+ .Navbar_links__8lRvB {
        padding: 0px 20px;
        font-size: 14px;
    }
    
    .Navbar_logo__o8J8F {
        width: 45px;
        height: 55px;
    }
    
    .Navbar_mainDiv__JYREL {
        width: 75%;
    }
}

@media (max-width: 768px) {
    .Navbar_desktopNavbar__U7\\+gs {
        display: none;
    }
    
    .Navbar_mobileBottomNav__kwCM9 {
        display: block;
    }
    
    body {
        padding-bottom: 90px;
    }
}

@media (max-width: 480px) {
    .Navbar_mobileNavContainer__uuy9O {
        padding: 10px 6px;
        border-radius: 20px;
    }
    
    .Navbar_navItem__Ix8Nh {
        padding: 8px 10px;
    }
    
    .Navbar_navItem__Ix8Nh.Navbar_active__zz1Pj {
        padding: 8px 14px;
    }
    
    .Navbar_navIcon__jwXGd {
        width: 22px;
        height: 22px;
    }
    
    .Navbar_navLabel__n1r8s {
        font-size: 11px;
    }
}


[dir="rtl"] .Navbar_navContent__2rqnf {
    flex-direction: row-reverse;
}

[dir="rtl"] .Navbar_navLabel__n1r8s {
    transform: translateX(10px);
}

[dir="rtl"] .Navbar_navItem__Ix8Nh.Navbar_active__zz1Pj .Navbar_navLabel__n1r8s {
    transform: translateX(0);
}
/* Floating Search Button */
.Navbar_floatingSearchBtn__zvNiy {
    display: none;
    position: fixed;
    bottom: 30px;
    right: 20px;
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, #015933 0%, #013d26 100%);
    border: none;
    border-radius: 50%;
    color: white;
    cursor: pointer;
    box-shadow: 0 4px 20px rgba(1, 89, 51, 0.3);
    z-index: 1001;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.2);
}

.Navbar_floatingSearchBtn__zvNiy:hover {
    transform: scale(1.1) translateY(-2px);
    box-shadow: 0 6px 25px rgba(1, 89, 51, 0.4);
}

.Navbar_floatingSearchBtn__zvNiy:active {
    transform: scale(0.95);
}

.Navbar_floatingSearchBtn__zvNiy svg {
    width: 24px;
    height: 24px;
}

.Navbar_mobileSearchOverlay__\\+t1p6 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    z-index: 1002;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    animation: Navbar_fadeIn__k1wmI 0.3s ease-out;
}

@keyframes Navbar_fadeIn__k1wmI {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.Navbar_mobileSearchContainer__gERQI {
    background: #ffffff;
    border-radius: 20px;
    padding: 20px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 10px 40px rgba(1, 89, 51, 0.2);
    border: 2px solid rgba(1, 89, 51, 0.1);
    display: flex;
    flex-direction: column;
    gap: 15px;
    animation: Navbar_slideUp__829wJ 0.3s ease-out;
}

@keyframes Navbar_slideUp__829wJ {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.Navbar_mobileSearchHeader__oJx40 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.Navbar_mobileSearchTitle__fltYg {
    font-size: 18px;
    font-weight: 600;
    color: #015933;
    margin: 0;
}

.Navbar_closeSearchBtn__\\+h2ow {
    background: rgba(1, 89, 51, 0.1);
    border: none;
    color: #015933;
    padding: 8px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    width: 36px;
    height: 36px;
}

.Navbar_closeSearchBtn__\\+h2ow:hover {
    background-color: rgba(1, 89, 51, 0.2);
    transform: scale(1.1);
}

/* Show floating button only on Phone */
@media (max-width: 768px) {
    .Navbar_floatingSearchBtn__zvNiy {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

@media (max-width: 480px) {
    .Navbar_floatingSearchBtn__zvNiy {
        width: 50px;
        height: 50px;
        bottom: 25px;
        right: 15px;
    }
    
    .Navbar_floatingSearchBtn__zvNiy svg {
        width: 20px;
        height: 20px;
    }
    
    .Navbar_mobileSearchContainer__gERQI {
        padding: 15px;
        border-radius: 15px;
    }
    
    .Navbar_mobileSearchTitle__fltYg {
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Navbar.module.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,YAAY;IACZ,0BAA0B;IAC1B,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;;;AAGA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,8CAA8C;IAC9C,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,0BAA0B;IAC1B,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,OAAO;AACX;;;;AAIA;IACI,YAAY;IACZ,kBAAkB;IAClB,kEAAkE;AACtE;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,4BAA4B;IAC5B,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,8CAA8C;IAC9C,sCAAsC;IACtC,YAAY;IACZ,iDAAkC;AACtC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,wEAAwE;AAC5E;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;;AAEA,4BAA4B;AAC5B;IACI;QACI,UAAU;QACV,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;;AAGA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;AACA,2BAA2B;AAC3B;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,2CAA2C;IAC3C,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,sCAAsC;IACtC,2CAA2C;AAC/C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,6CAA+B;AACnC;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,4CAA4C;IAC5C,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,8CAAgC;AACpC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA,uCAAuC;AACvC;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Desktop Navbar  */\r\n.desktopNavbar {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: auto;\r\n    min-height: 65px;\r\n    top: 50px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center; \r\n    z-index: 100;\r\n    padding: 0 15px;\r\n    z-index: 9999;\r\n}\r\n\r\n.desktopNavbar .container {\r\n    width: 100%;\r\n    background-color: #ffffff6b;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 15px;\r\n    border-radius: 16px;\r\n    position: relative;\r\n    max-height: 65px;\r\n    backdrop-filter: blur(10px);\r\n}\r\n\r\n.mainDiv {\r\n    width: 80%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.logo {\r\n    width: 50px;\r\n    height: 60px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.logo img {\r\n    max-width: 100%;\r\n    height: 100%;\r\n    border-radius: 16px;\r\n    object-fit: cover;\r\n}\r\n\r\n.menu {\r\n    list-style: none;\r\n    display: flex;\r\n    margin: 0;\r\n    padding: 0;\r\n    align-items: center;\r\n    gap: 8px; \r\n}\r\n\r\n.menu li {\r\n    margin: 0;\r\n}\r\n\r\n.menu .links {\r\n    padding: 10px 20px;\r\n    text-decoration: none;\r\n    color: rgba(1, 89, 51, 0.6);\r\n    white-space: nowrap;\r\n    transition: all 0.3s ease;\r\n    font-weight: 500;\r\n    display: block;\r\n    border-radius: 20px;\r\n    position: relative;\r\n    overflow: hidden;\r\n    min-width: auto;\r\n}\r\n\r\n.menu .links:hover {\r\n    color: #ccc;\r\n}\r\n.menu .links::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: -100%;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(135deg, #015933 0%, #013d26 100%);\r\n    opacity: 0.9;\r\n    transition: left 0.4s ease;\r\n    z-index: -1;\r\n    border-radius: 20px;\r\n}\r\n\r\n.menu .links.active::before {\r\n    left: 0;\r\n}\r\n\r\n.menu .links.active {\r\n    color: white;\r\n    padding: 10px 24px;\r\n}\r\n\r\n.menu .links:hover {\r\n    color: rgba(1, 89, 51, 0.8);\r\n    transform: translateY(-2px);\r\n}\r\n\r\n\r\n.desktopSearch {\r\n    display: block;\r\n    flex-shrink: 0;\r\n    /* width: 20%; */\r\n}\r\n\r\n/* Mobile Bottom Navigation */\r\n.mobileBottomNav {\r\n    display: none;\r\n    position: fixed;\r\n    top: 50px;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 1000;\r\n    padding: 0 10px 10px;\r\n}\r\n\r\n.mobileNavContainer {\r\n    background-color: #ffffff6b;;\r\n    backdrop-filter: blur(10px);\r\n    border-radius: 25px;\r\n    padding: 12px 8px;\r\n    display: flex;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n    box-shadow: 0 -10px 40px rgba(1, 89, 51, 0.15);\r\n    border: 2px solid rgba(1, 89, 51, 0.1);\r\n    margin: 0 auto;\r\n}\r\n\r\n.navItem {\r\n    display: flex;\r\n    align-items: center;\r\n    text-decoration: none;\r\n    color: rgba(1, 89, 51, 0.6);\r\n    transition: all 0.3s ease;\r\n    border-radius: 20px;\r\n    padding: 10px 12px;\r\n    position: relative;\r\n    overflow: hidden;\r\n    min-width: 50px;\r\n    justify-content: center;\r\n}\r\n\r\n.navItem::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: -100%;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(135deg, #015933 0%, #013d26 100%);\r\n    transition: left 0.4s ease;\r\n    z-index: -1;\r\n    border-radius: 20px;\r\n}\r\n\r\n.navItem.active::before {\r\n    left: 0;\r\n}\r\n\r\n\r\n\r\n.navItem.active {\r\n    color: white;\r\n    padding: 10px 16px;\r\n    /* min-width: auto; if it made a problem for the nav get it back */\r\n}\r\n\r\n.navItem:hover {\r\n    color: rgba(1, 89, 51, 0.8);\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.navItem:hover .navIcon {\r\n    transform: scale(1.1);\r\n}\r\n\r\n.navContent {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.navIcon {\r\n    width: 24px;\r\n    height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.navIcon img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n    filter: opacity(0.8);\r\n    transition: filter 0.3s ease;\r\n}\r\n\r\n.navIcon svg {\r\n    width: 24px;\r\n    height: 24px;\r\n    opacity: 0.8;\r\n    transition: opacity 0.3s ease;\r\n}\r\n\r\n.navItem.active .navIcon img {\r\n    filter: brightness(0) invert(1);\r\n}\r\n\r\n.navItem.active .navIcon svg {\r\n    color: white;\r\n    opacity: 1;\r\n}\r\n\r\n.navLabel {\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    opacity: 0;\r\n    transform: translateX(-10px);\r\n    transition: all 0.3s ease;\r\n    max-width: 0;\r\n    overflow: hidden;\r\n}\r\n\r\n.navItem.active .navLabel {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n    max-width: 100px;\r\n}\r\n\r\n/* Phone Search  */\r\n.mobileSearchOverlay {\r\n    position: absolute;\r\n    top: 75px;\r\n    left: 10px;\r\n    right: 10px;\r\n    background: #ffffff6b;\r\n    backdrop-filter: blur(20px);\r\n    border-radius: 25px;\r\n    padding: 15px;\r\n    box-shadow: 0 -10px 40px rgba(1, 89, 51, 0.15);\r\n    border: 2px solid rgba(1, 89, 51, 0.1);\r\n    z-index: 999;\r\n    animation: slideDown 0.3s ease-out;\r\n}\r\n\r\n@keyframes slideDown {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(-20px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.mobileSearchContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.mobileSearchContainer .searchContainer {\r\n    flex: 1;\r\n}\r\n\r\n.closeSearchBtn {\r\n    background: none;\r\n    border: none;\r\n    color: #015933;\r\n    padding: 8px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: all 0.3s ease;\r\n    width: 36px;\r\n    height: 36px;\r\n}\r\n\r\n.closeSearchBtn:hover {\r\n    background-color: rgba(1, 89, 51, 0.1);\r\n    transform: scale(1.1);\r\n}\r\n\r\n/* Search Item Button Styles */\r\n.searchItem {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-family: inherit;\r\n}\r\n\r\n.searchItem.active {\r\n    background: linear-gradient(135deg, #015933 0%, #013d26 100%) !important;\r\n}\r\n\r\n.searchItem.active::before {\r\n    left: 0;\r\n}\r\n\r\n.navItem, .searchItem {\r\n    display: flex;\r\n    align-items: center;\r\n    text-decoration: none;\r\n    color: rgba(1, 89, 51, 0.6);\r\n    transition: all 0.3s ease;\r\n    border-radius: 20px;\r\n    padding: 10px 12px;\r\n    position: relative;\r\n    overflow: hidden;\r\n    min-width: 50px;\r\n    justify-content: center;\r\n}\r\n\r\n/* Phone Search Responsive */\r\n@media (max-width: 480px) {\r\n    .mobileSearchOverlay {\r\n        top: -65px;\r\n        padding: 12px;\r\n        border-radius: 20px;\r\n    }\r\n    \r\n    .closeSearchBtn {\r\n        width: 32px;\r\n        height: 32px;\r\n    }\r\n}\r\n\r\n@media (min-width: 576px) {\r\n    .container, .containerSm {\r\n        max-width: 540px;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .container, .containerMd {\r\n        max-width: 720px;\r\n    }\r\n    \r\n    .mobileNavContainer {\r\n        padding: 14px 10px;\r\n    }\r\n    \r\n    .navIcon {\r\n        width: 26px;\r\n        height: 26px;\r\n    }\r\n    \r\n    .navLabel {\r\n        font-size: 13px;\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .container, .containerLg {\r\n        max-width: 960px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .container, .containerXl {\r\n        max-width: 1140px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n    .container, .containerXxl {\r\n        max-width: 1320px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n    .container, .containerXxxl {\r\n        max-width: 1500px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1920px) {\r\n    .container, .container4k {\r\n        max-width: 1800px;\r\n    }\r\n}\r\n\r\n/* Phone Responsive  */\r\n@media (max-width: 1024px) {\r\n    .menu .links {\r\n        padding: 0px 20px;\r\n        font-size: 14px;\r\n    }\r\n    \r\n    .logo {\r\n        width: 45px;\r\n        height: 55px;\r\n    }\r\n    \r\n    .mainDiv {\r\n        width: 75%;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .desktopNavbar {\r\n        display: none;\r\n    }\r\n    \r\n    .mobileBottomNav {\r\n        display: block;\r\n    }\r\n    \r\n    body {\r\n        padding-bottom: 90px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .mobileNavContainer {\r\n        padding: 10px 6px;\r\n        border-radius: 20px;\r\n    }\r\n    \r\n    .navItem {\r\n        padding: 8px 10px;\r\n    }\r\n    \r\n    .navItem.active {\r\n        padding: 8px 14px;\r\n    }\r\n    \r\n    .navIcon {\r\n        width: 22px;\r\n        height: 22px;\r\n    }\r\n    \r\n    .navLabel {\r\n        font-size: 11px;\r\n    }\r\n}\r\n\r\n\r\n[dir=\"rtl\"] .navContent {\r\n    flex-direction: row-reverse;\r\n}\r\n\r\n[dir=\"rtl\"] .navLabel {\r\n    transform: translateX(10px);\r\n}\r\n\r\n[dir=\"rtl\"] .navItem.active .navLabel {\r\n    transform: translateX(0);\r\n}\r\n/* Floating Search Button */\r\n.floatingSearchBtn {\r\n    display: none;\r\n    position: fixed;\r\n    bottom: 30px;\r\n    right: 20px;\r\n    width: 56px;\r\n    height: 56px;\r\n    background: linear-gradient(135deg, #015933 0%, #013d26 100%);\r\n    border: none;\r\n    border-radius: 50%;\r\n    color: white;\r\n    cursor: pointer;\r\n    box-shadow: 0 4px 20px rgba(1, 89, 51, 0.3);\r\n    z-index: 1001;\r\n    transition: all 0.3s ease;\r\n    backdrop-filter: blur(10px);\r\n    border: 2px solid rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.floatingSearchBtn:hover {\r\n    transform: scale(1.1) translateY(-2px);\r\n    box-shadow: 0 6px 25px rgba(1, 89, 51, 0.4);\r\n}\r\n\r\n.floatingSearchBtn:active {\r\n    transform: scale(0.95);\r\n}\r\n\r\n.floatingSearchBtn svg {\r\n    width: 24px;\r\n    height: 24px;\r\n}\r\n\r\n.mobileSearchOverlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    backdrop-filter: blur(10px);\r\n    z-index: 1002;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 20px;\r\n    animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n    }\r\n    to {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.mobileSearchContainer {\r\n    background: #ffffff;\r\n    border-radius: 20px;\r\n    padding: 20px;\r\n    width: 100%;\r\n    max-width: 400px;\r\n    box-shadow: 0 10px 40px rgba(1, 89, 51, 0.2);\r\n    border: 2px solid rgba(1, 89, 51, 0.1);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    animation: slideUp 0.3s ease-out;\r\n}\r\n\r\n@keyframes slideUp {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(30px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.mobileSearchHeader {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.mobileSearchTitle {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: #015933;\r\n    margin: 0;\r\n}\r\n\r\n.closeSearchBtn {\r\n    background: rgba(1, 89, 51, 0.1);\r\n    border: none;\r\n    color: #015933;\r\n    padding: 8px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: all 0.3s ease;\r\n    width: 36px;\r\n    height: 36px;\r\n}\r\n\r\n.closeSearchBtn:hover {\r\n    background-color: rgba(1, 89, 51, 0.2);\r\n    transform: scale(1.1);\r\n}\r\n\r\n/* Show floating button only on Phone */\r\n@media (max-width: 768px) {\r\n    .floatingSearchBtn {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .floatingSearchBtn {\r\n        width: 50px;\r\n        height: 50px;\r\n        bottom: 25px;\r\n        right: 15px;\r\n    }\r\n    \r\n    .floatingSearchBtn svg {\r\n        width: 20px;\r\n        height: 20px;\r\n    }\r\n    \r\n    .mobileSearchContainer {\r\n        padding: 15px;\r\n        border-radius: 15px;\r\n    }\r\n    \r\n    .mobileSearchTitle {\r\n        font-size: 16px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"desktopNavbar": `Navbar_desktopNavbar__U7+gs`,
	"container": `Navbar_container__6oUZ-`,
	"mainDiv": `Navbar_mainDiv__JYREL`,
	"logo": `Navbar_logo__o8J8F`,
	"menu": `Navbar_menu__KEoY+`,
	"links": `Navbar_links__8lRvB`,
	"active": `Navbar_active__zz1Pj`,
	"desktopSearch": `Navbar_desktopSearch__w-BXb`,
	"mobileBottomNav": `Navbar_mobileBottomNav__kwCM9`,
	"mobileNavContainer": `Navbar_mobileNavContainer__uuy9O`,
	"navItem": `Navbar_navItem__Ix8Nh`,
	"navIcon": `Navbar_navIcon__jwXGd`,
	"navContent": `Navbar_navContent__2rqnf`,
	"navLabel": `Navbar_navLabel__n1r8s`,
	"mobileSearchOverlay": `Navbar_mobileSearchOverlay__+t1p6`,
	"slideDown": `Navbar_slideDown__p2+PX`,
	"mobileSearchContainer": `Navbar_mobileSearchContainer__gERQI`,
	"searchContainer": `Navbar_searchContainer__vOYsE`,
	"closeSearchBtn": `Navbar_closeSearchBtn__+h2ow`,
	"searchItem": `Navbar_searchItem__qanZu`,
	"containerSm": `Navbar_containerSm__xYDlg`,
	"containerMd": `Navbar_containerMd__448Gs`,
	"containerLg": `Navbar_containerLg__3IKqO`,
	"containerXl": `Navbar_containerXl__BKbG4`,
	"containerXxl": `Navbar_containerXxl__bYKFr`,
	"containerXxxl": `Navbar_containerXxxl__QrWWx`,
	"container4k": `Navbar_container4k__OG6to`,
	"floatingSearchBtn": `Navbar_floatingSearchBtn__zvNiy`,
	"fadeIn": `Navbar_fadeIn__k1wmI`,
	"slideUp": `Navbar_slideUp__829wJ`,
	"mobileSearchHeader": `Navbar_mobileSearchHeader__oJx40`,
	"mobileSearchTitle": `Navbar_mobileSearchTitle__fltYg`
};
export default ___CSS_LOADER_EXPORT___;
